import type Store from "@ember-data/store";
import type ApplicationInstance from "@ember/application/instance";

export function initialize(appInstance: ApplicationInstance): void {
  const store = appInstance.lookup("service:store") as Store;

  const data = {
    generic: ["general"],
    nephro: ["transplant", "donor", "mrc", "generic"],
    pneumo: ["transplant", "generic"],
    hepato: ["transplant", "generic"],
    onco: [
      "breast-cancer-tnm0",
      "breast-cancer",
      "lymphoma-cancer",
      "myeloma-cancer",
      "hemato-cancer",
      "colon-cancer",
      "lung-cancer",
      "prostate-cancer",
      "ovarian-cancer",
      "testicular-cancer",
      "brain-cancer",
      "pancreatic-cancer",
      "liver-cancer",
      "kidney-cancer",
      "stomach-cancer",
      "cervix-cancer",
      "skin-cancer",
      "generic"
    ],
    cardio: ["transplant", "heart-failure", "generic"],
    mental: ["bipolar", "depression", "generic"],
    diabeto: ["dt2", "generic"],
    digest: ["crohn", "rch", "generic"]
  };

  Object.entries(data).forEach(([therapeuticalAreaId, subFollowUpReason]) => {
    const therapeuticalArea = store.peekRecord(
      "therapeutical-area",
      therapeuticalAreaId
    );
    subFollowUpReason.forEach(name =>
      store.createRecord("follow-up-reason", {
        id: `${therapeuticalAreaId}-${name}`,
        therapeuticalArea
      })
    );
  });
}

export default {
  after: "therapeutical-areas",
  initialize
};
